/* "Como está o seu cabelo hoje?" — troca de linha.

   No computador continua no passar do mouse. O problema era o celular, onde
   hover não existe: cada pergunta era um link, então tocar levava embora e a
   pessoa nunca via as outras fotos. Aqui:

   · tocar numa pergunta que NÃO é a atual só troca o cartão (segura o link);
     tocar na que já está aberta leva para a linha. O "Comprar" do cartão
     continua sendo o caminho direto;
   · arrastar o dedo no cartão passa para a próxima linha;
   · setas do teclado andam pela lista;
   · enquanto a seção está na tela ele gira sozinho, e para de vez assim que
     alguém interage.

   Tudo isso vale igual no computador — o mouse só chega antes. */
(function () {
  'use strict';

  var reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function montar(raiz) {
    if (raiz.dataset.phPronto) return;
    raiz.dataset.phPronto = '1';

    var cartao = raiz.querySelector('[data-ph-cartao]');
    var opcoes = Array.prototype.slice.call(raiz.querySelectorAll('[data-ph-opcao]'));
    var paineis = cartao ? Array.prototype.slice.call(cartao.querySelectorAll('[data-ph-painel]')) : [];
    if (!cartao || !opcoes.length) return;

    var atual = 0;
    var iniciado = false;
    var interagiu = false;
    var relogio = null;
    var segundos = parseFloat(raiz.dataset.phAuto) || 0;

    function mostrar(i, rolar) {
      i = (i + opcoes.length) % opcoes.length;
      if (i === atual && iniciado) return;
      iniciado = true;
      atual = i;

      opcoes.forEach(function (o, k) {
        if (k === i) o.setAttribute('aria-current', 'true');
        else o.removeAttribute('aria-current');
      });

      paineis.forEach(function (p, k) {
        p.hidden = k !== i;
        p.classList.remove('is-entrando');
      });

      var vivo = paineis[i];
      if (vivo && !reduzido) {
        /* reflow forçado: sem isto o navegador junta remover e adicionar a
           classe na mesma pintura e a animação não roda de novo. */
        void vivo.offsetWidth;
        vivo.classList.add('is-entrando');
      }

      /* no celular a lista é um trilho: a pergunta escolhida precisa estar à
         vista, senão a pessoa toca e parece que nada aconteceu */
      if (rolar) {
        var alvo = opcoes[i];
        var lista = alvo.closest('.ph-desafio__lista');
        if (lista && lista.scrollWidth > lista.clientWidth) {
          lista.scrollTo({
            left: alvo.offsetLeft - (lista.clientWidth - alvo.offsetWidth) / 2,
            behavior: reduzido ? 'auto' : 'smooth'
          });
        }
      }
    }

    /* --- giro sozinho ---
       `desliga` é pausa (seção fora da tela, aba escondida). `parar` é
       definitivo: quem interagiu não quer mais o carrossel decidindo por ele.
       Separar os dois importa porque o observer dispara logo ao observar, e
       na primeira pintura a seção quase nunca está visível — com um só método
       o giro morria antes de começar. */
    function liga() {
      if (interagiu || relogio || segundos <= 0 || reduzido || opcoes.length < 2) return;
      relogio = setInterval(function () {
        if (document.hidden) return;
        mostrar(atual + 1, true);
      }, segundos * 1000);
    }
    function desliga() {
      if (relogio) { clearInterval(relogio); relogio = null; }
    }
    function parar() {
      interagiu = true;
      desliga();
    }

    opcoes.forEach(function (o, i) {
      o.addEventListener('mouseenter', function () { parar(); mostrar(i, false); });
      o.addEventListener('focus', function () { parar(); mostrar(i, true); });

      o.addEventListener('click', function (e) {
        parar();
        /* Só segura o link quando a pergunta ainda não está aberta: no toque o
           primeiro contato revela e o segundo leva para a linha; no computador
           o mouse já abriu, então o clique passa direto. */
        if (i !== atual) {
          e.preventDefault();
          mostrar(i, true);
        }
      });

      o.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        parar();
        var passo = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        var prox = (i + passo + opcoes.length) % opcoes.length;
        mostrar(prox, true);
        opcoes[prox].focus();
      });
    });

    /* --- arrastar o dedo no cartão --- */
    var x0 = null, y0 = null;
    cartao.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    cartao.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      /* o dobro na horizontal, senão rolar a página troca o cartão sem querer */
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 2) return;
      parar();
      mostrar(atual + (dx < 0 ? 1 : -1), true);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) { e.isIntersecting ? liga() : desliga(); });
      }, { threshold: 0.25 }).observe(raiz);
    } else {
      liga();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) desliga();
    });
  }

  function iniciar(escopo) {
    (escopo || document).querySelectorAll('[data-ph-desafio]').forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  } else {
    iniciar();
  }

  /* o editor recarrega a seção sem recarregar a página */
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
